<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :has-details-row="true"
            :per-page="250"
            :selectable-rows="false"
          >
            <template #row-details="row">
              <customers-table-details-row :row="row" />
            </template>
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(customerNumber)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.customerNumber" />
            </template>
            <template #head(name1)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.name1" />
            </template>
            <template #head(name2)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.name2" />
            </template>
            <template #head(street)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.street" />
            </template>
            <template #head(zip)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.zip" />
            </template>
            <template #head(city)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.city" />
            </template>
            <template #head(state)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.state" />
            </template>
            <template #head(salesRepresentative)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.salesRepresentative"
                input-type="number"
              />
            </template>
            <template #head(accountConditions)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.accountConditions"
                input-type="number"
              />
            </template>
            <template #head(currency)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.currency" />
            </template>
            <template #head(customerGroup)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.customerGroup"
                input-type="number"
              />
            </template>
            <template #head(assessment)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.assessment"
                input-type="number"
              />
            </template>
            <template #head(salesTerritory)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.salesTerritory"
                input-type="number"
              />
            </template>
            <template #head(matchcode)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.matchcode" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import TableFilter from '../../table/table-filter';
import {CustomerMixin, NotificationMixin} from '../../../mixins';
import CustomersTableDetailsRow from './customers-table-details-row';
import PageHeader from '../../structure/page-header';

const evaluationArray = Array.from({ length: 10 }, (_, i) => i + 1);

export default {
  name: 'Customers',
  components: {PageHeader, CustomersTableDetailsRow, DataTable, TableFilter},
  mixins: [CustomerMixin, NotificationMixin],
  data: function () {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          { key: 'check', label: '' },
          { key: 'company', label: this.$translate('company'),  sortable: true },
          { key: 'customerNumber', label: this.$translate('account'),  sortable: true },
          { key: 'status', label: this.$translate('status'),  sortable: true },
          { key: 'name1', label: this.$translate('name1'),  sortable: true },
          { key: 'name2', label: this.$translate('name2'),  sortable: true},
          { key: 'street', label: this.$translate('street'),  sortable: true },
          { key: 'zip', label: this.$translate('zip_short'),  sortable: true},
          { key: 'city', label: this.$translate('city'),  sortable: true },
          { key: 'state', label: this.$translate('state'),  sortable: true },
          { key: 'salesRepresentative', label: this.$translate('sales_representative'),  tdClass: 'center' , sortable: true},
          { key: 'accountConditions', label: this.$translate('account_conditions'),  tdClass: 'center', sortable: true },
          { key: 'currency', label: this.$translate('currency'),  tdClass: 'center', sortable: true },
          { key: 'deliveryInformation1', label: `${this.$translate('delivery_information')} 1`,  sortable: true},
          { key: 'deliveryInformation2', label: `${this.$translate('delivery_information')} 2`,  sortable: true},
          { key: 'customerGroup', label: this.$translate('customer_group'),  tdClass: 'center' , sortable: true},
          { key: 'assessment', label: this.$translate('assessment'), tdClass: 'center',  sortable: true },
          ...evaluationArray.map((item) => ({
            key: `evaluation${item}`,
            label: `${this.$translate('evaluation')} ${item}`,
            tdClass: 'center',
            sortable: true
          })),
          { key: 'salesTerritory', label: this.$translate('sales_territory'),  tdClass: 'center' , sortable: true},
          { key: 'matchcode', label: this.$translate('matchcode'),  sortable: true},
          { key: 'tel', label: this.$translate('tel'),  sortable: true },
          { key: 'email', label: this.$translate('email'),  sortable: true }
        ],
        filter: {
          company: null,
          customerNumber: null,
          name1: null,
          name2: null,
          street: null,
          zip: null,
          city: null,
          state: null,
          salesRepresentative: null,
          accountConditions: null,
          currency: null,
          customerGroup: null,
        }
      },
    };
  },
  methods: {
    async getPage(params) {
      try {
        const response = await this.customerService.getPage(params);
        return {totalCount: response.totalCount, data: response.data};
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    }
  }
};
</script>

<style scoped lang="scss">

  ::v-deep   .table {
  min-width: 1200px;
  overflow: scroll;
    td, th {
      word-break: break-word;
      &.w50 {
        width: 50px;
      }
      &.w100 {
        width: 100px;
      }
      &.w150 {
        width: 150px;
      }
      &.w200 {
        width: 200px;
      }
      &.center {
        text-align: center;
      }
    }
  }

  // ::v-deep   .main-content {
  //   overflow: hidden;
  // }

  ::v-deep   .filters-container {
    padding: 0;
  }
</style>
